import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError, Form, formValueSelector } from 'redux-form';
import TagEditor from 'appSrc/components/Tag/Editor';
import { validateWebUrl, addTransferProtocol } from 'appSrc/utils';
import validate from 'appSrc/utils/formValidate';
import { PrimaryButton } from 'appSrc/components/UI';
import { FormTextField, FormTextArea } from 'appSrc/components/UI/ReduxForm';
import style from '../styles/style.module.css';


class StepTwoForm extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            tags: [],
        };
    }
    updateTags = ( tags ) => {
        this.setState( { tags } );
    }
    handleSubmit = ( data ) => {
        var values = { ...data };

        values.tags = this.state.tags;
        if( !!values.externalurl ) {
            if( !validateWebUrl( values.externalurl ) ) {
                throw new SubmissionError( { externalurl: 'Invalid url' } );
            }
            values.externalurl = addTransferProtocol( values.externalurl );
        }
        this.props.onSubmit( values );
    }
    render() {
        const { handleSubmit, submitting, valid, fields } = this.props;

        return (
            <Form className={ style.stepTwoForm } onSubmit={ handleSubmit( this.handleSubmit ) } >
                <Field
                id='description'
                name='description'
                label='Describe your list'
                component={ FormTextArea }
                validate={ [ validate.required ] }
                fullWidth
                autoFocus
                required />

                <TagEditor
                label='Add Tags (Optional)'
                onUpdate={ this.updateTags }
                channel={ this.props.channel }
                childRef={ ( el ) => { this.tagEditor = el; } } />

                <Field
                id='externalurl'
                name='externalurl'
                label='External Site Link (Optional)'
                component={ FormTextField }
                fullWidth />

                { fields.externalurl &&
                    <Field
                    id='externalurldisplaytext'
                    name='externalurldisplaytext'
                    label='External Site Title (Optional)'
                    component={ FormTextField }
                    fullWidth />
                }

                <div className={ style.buttonWrapper }>
                    <PrimaryButton
                    label="Next"
                    type='submit'
                    fullWidth
                    disabled={ !valid || submitting } />
                </div>
                { this.props.error &&
                    <div className={ style.errorBlock }>{ this.props.error }</div>
                }
            </Form>
        );
    }
}

StepTwoForm = reduxForm( {
    form: 'ListCreationStepTwoForm',
} )( StepTwoForm );

const selector = formValueSelector( 'ListCreationStepTwoForm' );

const mapStateToProps = ( state ) => {
    return {
        user: state.self.user,
        ownLists: state.self.lists,
        fields: selector( state, 'externalurl', 'externalurldisplaytext' ),
    };
};

export default connect( mapStateToProps )( StepTwoForm );
//
